import { Users } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth';
import { Erro, Spinner } from '../componentes/base';

export default function Login() {
  const { entrar } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [aEntrar, setAEntrar] = useState(false);

  async function submeter(evento: FormEvent) {
    evento.preventDefault();
    setErro(null);
    setAEntrar(true);
    try {
      await entrar(email, password);
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não foi possível iniciar sessão.');
    } finally {
      setAEntrar(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-papel-100 px-4 dark:bg-tinta-900">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 rounded-xl bg-marca-500 p-3 text-white">
            <Users className="h-7 w-7" aria-hidden />
          </div>
          <h1 className="text-xl font-semibold">Gestão de Assistentes de Sala</h1>
          <p className="mt-1 text-sm text-tinta-500 dark:text-tinta-400">
            Inicie sessão para continuar
          </p>
        </div>

        <form onSubmit={submeter} className="cartao space-y-4 p-6">
          {erro && <Erro mensagem={erro} />}

          <div>
            <label htmlFor="email" className="rotulo">Email</label>
            <input
              id="email" type="email" className="campo" value={email} required
              autoComplete="username" autoFocus
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nome@empresa.pt"
            />
          </div>

          <div>
            <label htmlFor="password" className="rotulo">Palavra-passe</label>
            <input
              id="password" type="password" className="campo" value={password} required
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="btn-primario w-full justify-center" disabled={aEntrar}>
            {aEntrar && <Spinner classe="h-4 w-4" />}
            {aEntrar ? 'A entrar…' : 'Entrar'}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-tinta-400">
          snip.work · beta ·{' '}
          <Link to="/privacidade" className="underline hover:text-tinta-600 dark:hover:text-papel-300">
            Privacidade
          </Link>
        </p>
      </div>
    </div>
  );
}
